import React from "react";
import OtherBenefit from "./BenefitDetailTable/OtherBenefit";
import { formatDate } from "./ProductDetails";
import { table, planWithPadding, planWithExtraPadding } from "../Shared/Styles";

import {
  subTitle,
  summary,
  hr,
} from "../Shared/Styles";

function BenefitDetails({ benefitDetails, policyOrigin, productDetails }) {
  var isBTLife = policyOrigin !== undefined && policyOrigin === "TLIS";
  var isHybridPremium = false;

if(productDetails !== undefined && productDetails[0].hasHybridPremium === true) {
  isHybridPremium = true;
}

  if (benefitDetails !== undefined) {
    return (
      <div className="BenefitDeatilsCompinent">
        <h3 style={{textAlign: 'left', marginLeft: '46px', marginBottom:'4px'}}>BENEFIT DETAILS</h3>
        {isBTLife && isHybridPremium &&
          <p style={{ color: 'red', marginLeft: '46px', fontWeight: "bold"}}>*This policy has a hybrid premium. The premium type on this page may not be accurate. Please refer to the most recent renewal statement for the hybrid premium breakdown</p>
        }
        <div>
          {benefitDetails.map((link) => (
            <>
            <br />
              <div style={summary}>
                SUMMARY FOR {link.lifeInsuredFirstName}
                {" "}
                {link.lifeInsuredSurName}
                <hr style={hr} />
              </div>  
              {isBTLife && 
                <div>
                  <span style={planWithPadding}>Sex:</span> 
                  <span style={{ fontSize: "15px" }}>
                      {link.gender !== null ? (link.gender === 'M' ? 'Male' : 'Female') : ''} {" "}
                  </span>
                  <span style={planWithExtraPadding}>Date of Birth:</span> 
                  <span style={{ fontSize: "15px" }}>
                      {link.dateOfBirth !== null ? formatDate(link.dateOfBirth) : ""} {" "}
                  </span>
                  <span style={planWithExtraPadding}>Smoker Status:</span> 
                  <span style={{ fontSize: "15px" }}>
                    {link.smokingStatus !== null ? (link.smokingStatus === 'S' ? 'Smoker' : 'Non Smoker') : ''} 
                  </span>
                </div>
              }
              <div>
                <table style={table}>
                  <OtherBenefit ob={link.benefitDetailsSub} policyOrigin={policyOrigin} />
                </table>
              </div>
            </>
          ))}
        </div>
      </div>
    );
  } else if (
    benefitDetails !== undefined &&
    benefitDetails.filter((e) => e.benefitDetailsSub.length > 0).length <= 0
  ) {
    return (
      <div>
        <h3 style={subTitle}>BENEFIT DETAILS</h3>
        <span style={summary}>There are no inforce benefits.</span>
      </div>
    );
  }
}

export default BenefitDetails;
